<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ (mode == 'new' ? 'Sperrung anlegen' : 'Sperrung bearbeiten') | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      @if (mode == 'edit') {
        <a
          href="javascript:void(0);"
          class="nav-link nav-icon tooltip tooltip-md tooltip-bottom-left"
          role="tooltip"
          aria-haspopup="true"
          (click)="switchMode('new')">
          <cds-icon shape="plus-circle" size="30" />
          <span class="tooltip-content">{{ 'Neue Sperrung anlegen' | mrTranslate }}</span>
        </a>
      }
      <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times" />
      </a>
    </div>
  </header>

  <!-- <div id="sperrungWrapper"> -->

  <form
    class="login"
    id="sperrungform"
    clrForm
    [formGroup]="sperrungGroup"
    (ngSubmit)="onSubmit()"
    style="margin-left: 20px; margin-right: 15px">
    <div class="clr-row" style="margin-top: -20px">
      <div class="clr-col-md-6 clr-col-12">
        <clr-date-container>
          <label class="clr-col-md-4">{{ 'Beginn der Sperrung' | mrTranslate }}</label>
          <input
            class="clr-col-md-8"
            type="date"
            name="date"
            clrDate
            [ngModel]="sperrungGroup.controls.date.value | localeDate"
            (ngModelChange)="sperrungGroup.controls.date.setValue(localeDate.tosql($event))"
            [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
            [disabled]="sperrungGroup.disabled" />
        </clr-date-container>
        <clr-input-container>
          <label class="clr-col-md-4">{{ 'Zeit Beginn' | mrTranslate }}</label>
          <input class="clr-col-md-8" clrInput placeholder="00:00" type="time" name="time" formControlName="time" />
        </clr-input-container>
        @if (mode == 'edit') {
          <clr-date-container>
            <label class="clr-col-md-4">{{ 'Ende der Sperrung' | mrTranslate }}</label>
            <input
              class="clr-col-md-8"
              type="date"
              name="edate"
              clrDate
              [ngModel]="sperrungGroup.controls.edate.value | localeDate"
              (ngModelChange)="sperrungGroup.controls.edate.setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              [disabled]="sperrungGroup.disabled" />
          </clr-date-container>
          <clr-input-container>
            <label class="clr-col-md-4">{{ 'Zeit Ende' | mrTranslate }}</label>
            <input class="clr-col-md-8" clrInput placeholder="00:00" type="time" name="etime" formControlName="etime" />
          </clr-input-container>
        }

        <div class="comboboxcontainer clr-form-control clr-row">
          <label class="clr-col-md-4 clr-control-label">{{ 'gemeldet durch' | mrTranslate }}</label>
          <div class="clr-control-container clr-col-md-8">
            <input
              class="clr-input combobox"
              [placeholder]="'Name' | mrTranslate"
              type="search"
              name="gemeldetDurch"
              formControlName="gemeldetDurch"
              list="gemeldetDurchList" />
          </div>
          <datalist id="gemeldetDurchList">
            @if (gemeldetDurch) {
              @for (name of gemeldetDurch; track name) {
                <option [value]="name"></option>
              }
            }
          </datalist>
        </div>

        @if (mode == 'edit') {
          <div class="comboboxcontainer clr-form-control clr-row">
            <label class="clr-col-md-4 clr-control-label">{{ 'aufgehoben durch' | mrTranslate }}</label>
            <div class="clr-control-container clr-col-md-8">
              <input
                class="clr-input combobox"
                [placeholder]="'Name' | mrTranslate"
                type="search"
                name="aufgehobenDurch"
                formControlName="aufgehobenDurch"
                list="aufgehobenDurchList" />
            </div>
            <datalist id="aufgehobenDurchList">
              @if (aufgehobenDurch) {
                @for (name of aufgehobenDurch; track name) {
                  <option [value]="name"></option>
                }
              }
            </datalist>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'line') {
          <div id="lineWrapper">
            <div class="clr-row">
              <div class="clr-col">
                <clr-checkbox-wrapper class="clr-row">
                  <input type="checkbox" clrCheckbox name="gesamtesGleis" formControlName="gl_g" />
                  <label>{{ 'Gesamtes Gleis' | mrTranslate }}</label>
                </clr-checkbox-wrapper>
                @if (sperrungGroup.errors?.['not-in-Direction']; as err) {
                  <div class="clr-row nxm clr-col-auto">
                    <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                      <clr-alert-item>
                        <span class="alert-text">
                          {{
                            'Der Startmeter muss ' + (err.upwards ? 'kleiner' : 'größer') + ' als der Endmeter sein'
                              | mrTranslate
                          }}
                        </span>
                      </clr-alert-item>
                    </clr-alert>
                  </div>
                }
                <div class="clr-row" [hidden]="sperrungGroup.value.gl_g">
                  <clr-input-container class="clr-col-6" clrInline>
                    <label class="clr-col-md-4">{{ 'von' | mrUnitText }}</label>
                    <input
                      class=""
                      clrInput
                      [placeholder]="startmeter !== undefined ? startmeter + '...' : '0'"
                      name="gleisVon"
                      formControlName="gl_v" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                    @if (sperrungGroup.controls.gl_v.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}
                      </clr-control-error>
                    }
                    @if (sperrungGroup.controls.gl_v.errors?.max; as err) {
                      <clr-control-error>{{ 'Der Wert ist größer als' | mrTranslate }} {{ err.max }}</clr-control-error>
                    }
                  </clr-input-container>
                  <clr-input-container class="clr-col-6" clrInline>
                    <label class="clr-col-md-4">{{ 'bis' | mrUnitText }}</label>
                    <input
                      class=""
                      clrInput
                      [placeholder]="endmeter !== undefined ? '...' + endmeter : '987'"
                      name="gleisBis"
                      formControlName="gl_b" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                    @if (sperrungGroup.controls.gl_b.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}
                      </clr-control-error>
                    }
                    @if (sperrungGroup.controls.gl_b.errors?.max; as err) {
                      <clr-control-error>{{ 'Der Wert ist größer als' | mrTranslate }} {{ err.max }}</clr-control-error>
                    }
                  </clr-input-container>
                </div>
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 1) {
          <div id="pointWrapper">
            <div class="clr-row">
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('2')"
                [ngClass]="{ active: sperrungGroup.value.ew == 2 }">
                <img class="vector" src="assets/icons/weichen/EW_blockStraight.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="2" formControlName="ew" />
                  <label class="radiolabel">{{ 'Gerade' | mrTranslate }}</label>
                </div>
              </div>
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('3')"
                [ngClass]="{ active: sperrungGroup.value.ew == 3 }">
                <img class="vector" src="assets/icons/weichen/EW_blockBranch.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="3" formControlName="ew" />
                  <label class="radiolabel">{{ 'Abzweig' | mrTranslate }}</label>
                </div>
              </div>
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('1')"
                [ngClass]="{ active: sperrungGroup.value.ew == 1 }">
                <img class="vector" src="assets/icons/weichen/EW_blockBoth.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="1" formControlName="ew" />
                  <label class="radiolabel">{{ 'Gerade und Abzweig' | mrTranslate }}</label>
                </div>
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 2) {
          <div id="pointDoubleWrapper">
            <div class="clr-row">
              <div class="clr-col padding-20-lr">
                <strong>A</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="a" formControlName="dw_a" />
              </div>
              <div class="clr-col">
                <strong>B</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="b" formControlName="dw_b" />
              </div>
              <div class="clr-col">
                <strong>C</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="c" formControlName="dw_c" />
              </div>
            </div>
            <div class="clr-row">
              <div class="clr-col">
                <img class="vector mw-50p" src="assets/icons/weichen/DW1.svg" />
              </div>
              <div class="clr-col">
                <img class="vector mw-50p" src="assets/icons/weichen/DW2.svg" />
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 3) {
          <div id="pointCrossWrapper" class="clr-row">
            <div class="checkboxes clr-col">
              <div>
                <strong>A</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="a" formControlName="kr_a" />
              </div>
              <div>
                <strong>B</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="b" formControlName="kr_b" />
              </div>
            </div>
            <img src="assets/icons/weichen/KR.svg" class="clr-col vector" />
            <div class="checkboxes right clr-col">
              <div>
                <input type="checkbox" clrCheckbox name="c" formControlName="kr_c" />
                &nbsp;
                <strong>C</strong>
              </div>
              <div>
                <input type="checkbox" clrCheckbox name="d" formControlName="kr_d" />
                &nbsp;
                <strong>D</strong>
              </div>
            </div>
          </div>
        }

        <div id="sperrForm">
          <clr-checkbox-wrapper class="clr-row">
            <input type="checkbox" clrCheckbox name="gesperrt" formControlName="gesperrt" />
            <label>{{ 'gesperrt' | mrTranslate }}</label>
          </clr-checkbox-wrapper>
          <clr-textarea-container class="clr-row">
            <label class="clr-col-md-4">{{ 'Grund' | mrTranslate }}</label>
            <textarea class="clr-col-md-8" clrTextarea name="grund" formControlName="grund"></textarea>
          </clr-textarea-container>
          <div class="clr-row">
            <button class="btn btn-primary" [disabled]="trial" type="submit">
              {{ (mode == 'new' ? 'Sperrung anlegen' : 'Sperrung speichern') | mrTranslate }}
            </button>
          </div>
        </div>
      </div>
      <div id="history" class="clr-col-md-6 clr-col-12 nopaddingright">
        <br />
        <h3>{{ 'Historie' | mrTranslate }}</h3>
        @if (history && history.columns) {
          <clr-datagrid class="datagrid-compact">
            @for (column of history.columns; track column) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                  {{ camelcase(column.id) | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of history.rows" [ngClass]="{ selectedrow: row.id == editId }">
              <clr-dg-action-overflow>
                <button class="action-item" (click)="editRow(row)">{{ 'Bearbeiten' | mrTranslate }}</button>
                <button type="button" class="action-item" (click)="emailSperrung(row)">
                  {{ 'Email' | mrTranslate }}
                </button>
              </clr-dg-action-overflow>
              @for (cell of history.columns; track cell) {
                @if (cell.id != 'richtung') {
                  <clr-dg-cell><app-dg-cell [data]="row[cell.id]" [col]="cell.id" /></clr-dg-cell>
                } @else {
                  <clr-dg-cell>
                    <cds-icon
                      class="grid-icon fill-black"
                      [shape]="row['richtung'] && pointtype ? 'richtung' + row['richtung'] : 'blank'"
                      size="32" />
                  </clr-dg-cell>
                }
              }
            </clr-dg-row>
            <clr-dg-footer>{{ 1 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>
    </div>
  </form>
</div>
<!-- </div> -->
